/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_ActionInputs */

const en_us2_share_action = /** @type {(inputs: Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const pt_br2_share_action = /** @type {(inputs: Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar`)
};

const es_419_share_action = /** @type {(inputs: Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

const pt_pt2_share_action = /** @type {(inputs: Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar`)
};

const fr_fr2_share_action = /** @type {(inputs: Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager`)
};

const de_de2_share_action = /** @type {(inputs: Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const it_it2_share_action = /** @type {(inputs: Share_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Share_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_action = /** @type {((inputs?: Share_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_action(inputs)
	if (locale === "es-419") return es_419_share_action(inputs)
	if (locale === "pt-PT") return pt_pt2_share_action(inputs)
	if (locale === "fr-FR") return fr_fr2_share_action(inputs)
	if (locale === "de-DE") return de_de2_share_action(inputs)
	if (locale === "it-IT") return it_it2_share_action(inputs)
	return en_us2_share_action(inputs)
});
export { share_action as "share.action" }